<template>
    <div class="configbar">
        
        <!--<div class="options">    
            <div class="single-option"
            :class="{'selected': $store.getters.getCurrentDepartment === department}"
            v-for="department in $store.getters.getAvailableDepartments" :key="department.uuid"
            @click="$store.commit('setCurrentDepartment', department)">
                {{ department.name }}
            </div>
            <div
                class="single-option"
                @click="goToCleanUp()"
                v-if="$store.getters.getAvailableDepartments.length > 1 && !$auth.user().name.includes('Demo')"
            >
                Ingen afdeling tilknyttet
            </div>
        </div>-->

        <div align="left" v-if="$auth.user().roles[0].name !== 'project-responsible'">
            <div v-if="$auth.user().roles[0].name === 'department-responsible' && selectedDepartment">
                <b>{{ selectedDepartment.name }}</b>
                <br>
                <i>Logget ind som afdelingsansvarlig</i>
            </div>
            <div v-else>
                <dropdown :options="departments" 
                    :selected="selectedDepartment" 
                    v-on:updateOption="selectDepartment" 
                    :placeholder="'Vælg afdeling'"
                    :closeOnOutsideClick="true"
                    v-if="selectedDepartment !== null"
                />
            </div>
        </div>

        <div class="date-range" v-if="$auth.user().roles[0].name !== 'project-responsible'">
            <div class="flex">
                <div style="white-space:nowrap;"><b>Vælg periode:</b></div>
                <datepicker monday-first :language="datepickerLocale" class="date-picker" v-model="$store.state.config.startDate" placeholder="Startdato"></datepicker>
                <div><i class="fal fa-chevron-right" /></div>
                <datepicker monday-first :language="datepickerLocale" class="date-picker" v-model="$store.state.config.endDate" placeholder="Slutdato"></datepicker>
            </div>
            <div class="custom-time-period">
                <!--<dropdown :options="customTimeIntervals" 
                    :selected="selectedTimePeriod" 
                    v-on:updateOption="selectTimePeriod"
                    :placeholder="'Vælg tidsinterval'"
                    :closeOnOutsideClick="true"
                />-->
                <select v-model="selectedTimePeriod" @change="selectTimePeriod($event)">
                    <option value="Vælg tidsinterval" selected disabled>Vælg tidsinterval &darr;</option>
                    <option v-for="(timeInterval, index) in customTimeIntervals" :key="index" :value="timeInterval.name" :startDate="2019" :endDate="2020">
                        {{ timeInterval.name }}
                    </option>
                </select>
            </div>
        </div>
        <div class="smart" align="right" v-if="$auth.user().roles[0].name !== 'project-responsible'">
            <div class="options reversed">
                <div style="white-space:nowrap;margin-right:30px;"><b>Vælg regnskabsår:</b></div>
                <div
                    class="single-option"
                    v-for="(accountingYear, index) in $store.state.config.availableAccountingYears"
                    :key="accountingYear.year"
                    v-if="index < 3"
                    :class="{'selected': accountingYear.from_date === $store.getters.getStartDate && accountingYear.to_date === $store.getters.getEndDate}"
                    @click="selectAccountingYear(accountingYear)"
                >
                    {{ accountingYear.year }}
                </div>
            </div>

            <!--<select @change="$store.dispatch('setDatesPreset', $event.target.value)" style="cursor: pointer">
                <option class="option" value="currentAccountingYear">Nyeste regnskabsår</option>
                <option class="option" value="currentMonth">Denne måned</option>
                <option class="option" value="currentWeek">Denne uge</option>
            </select>-->
        </div>
    </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker'
import { da } from 'vuejs-datepicker/dist/locale'
import dropdown from 'vue-dropdowns'
import moment from 'moment'

export default {
    data () {
        return {
            departments: [],
            selectedDepartment: null,
            selectedTimePeriod: 'Vælg tidsinterval',
            datepickerLocale: da
        }
    },
    mounted () {
        this.getDepartments()
    },
    methods: {
        selectAccountingYear (accountingYear) {
            let dates = {
                startDate: accountingYear.from_date,
                endDate: accountingYear.to_date
            }
            this.$store.commit('setDates', dates)
            this.selectedTimePeriod = 'Vælg tidsinterval'
        },
        goToCleanUp () {
            this.$router.push({name: 'Settings', params: {selected: 'cleanup'}})
        },
        getDepartments () {
            this.departments = this.$store.getters.getAvailableDepartments
            this.selectedDepartment = this.$store.getters.getCurrentDepartment
            this.departments.push({name: 'Ingen afdeling tilknyttet'})
            if (this.$auth.user().roles[0].name === 'department-responsible') {
                if (!this.$auth.user().department || !this.$auth.user().relation_department_id) {
                    alert('Din profil er oprettet som afdelingsansvarlig, men du er ikke tilknyttet en afdeling. Du logges nu ud af proEBITDA. Kontakt din administrator for at opdatere din brugerprofil.')
                    this.$auth.logout()
                }
                console.log('Du er afdelingsansvarlig! Nice...')
                this.selectDepartment(this.$auth.user().department)
                this.selectedDepartment = this.$auth.user().department
            }
        },
        selectDepartment (department) {
            this.selectedTimePeriod = 'Vælg tidsinterval'
            if (department.name === 'Ingen afdeling tilknyttet') {
                this.$router.push({name: 'Settings', params: {selected: 'cleanup'}})
            } else {
                this.$store.commit('setCurrentDepartment', department)
            }
        },
        selectTimePeriod (event) {
            this.customTimeIntervals.forEach((interval) => {
                if (interval.name === event.target.value) {
                    this.$store.state.config.startDate = interval.start
                    this.$store.state.config.endDate = interval.end
                }
            })
        }
    },
    components: {
        Datepicker,
        dropdown
    },
    computed: {
        startDate () {
            return this.$store.state.getters.getStartDate
        },
        customTimeIntervals () {
            let timeIntervals = [
                {
                    name: 'Denne uge',
                    start: moment().startOf('week').format('YYYY-MM-DD'),
                    end: moment().endOf('week').format('YYYY-MM-DD')
                },
                {
                    name: 'Sidste uge',
                    start: moment().subtract(1, 'week').startOf('week').format('YYYY-MM-DD'),
                    end: moment().subtract(1, 'week').endOf('week').format('YYYY-MM-DD')
                },
                {
                    name: 'Denne måned',
                    start: moment().startOf('month').format('YYYY-MM-DD'),
                    end: moment().endOf('month').format('YYYY-MM-DD')
                },
                {
                    name: 'Sidste 3 måneder',
                    start: moment().subtract(3, 'months').format('YYYY-MM-DD'),
                    end: moment().format('YYYY-MM-DD')
                },
                {
                    name: 'Sidste 6 måneder',
                    start: moment().subtract(6, 'months').format('YYYY-MM-DD'),
                    end: moment().format('YYYY-MM-DD')
                }
            ]
            return timeIntervals
        }
    }
}
</script>

<style lang="scss" scoped>
@import "../../styles/vars.scss";
    .configbar {
        position: fixed;
        top: 0;
        background: $color--white;
        box-shadow: $boxshadow--creative;
        // border-bottom: 1px solid $color--light;
        height: 80px;
        z-index: 99;
        padding: 0 $padding--large;
        display: flex;
        align-items: center;
        justify-content: space-between;
        left: 250px;
        width: calc(100% - 250px);
        font-size: $fontsize--sm;

        .options {
            white-space: nowrap;
            display: flex;
            align-items: center;
            justify-content: flex-start;

            &.reversed {
                justify-content: flex-end;
            }

            .single-option {
                padding: 2px 8px;
                transition: $transition--main;
                cursor: pointer;
                border-radius: $borderradius--main;

                &:hover {
                    background: rgba(0, 0, 0, 0.15);
                }

                &.selected {
                    background: $color--dark;
                    color: $color--white;
                }

                &:not(:last-of-type) {
                    margin-right: 15px;
                }
            }
        }

        > div {
            flex: 0 0 20%;
        }

        .super-admin,
        .logged-in-as {
            display: flex;
            justify-content: flex-end;

            > b {
                margin-right: 15px;
            }
        }

        .date-range .flex {
            display: flex;
            justify-content: center;

            > div:not(:first-of-type) {
                margin-left: 15px;
            }
        }

        .custom-time-period {
            text-align: center;
            margin-top: 10px;

            select {
                text-align: center;
                text-align-last: center;
                font-weight: 700;
            }
        }

        .fiscalyear {
            display: flex;
            align-items: center;
        }

        .select {
            display: flex;

            .option {
                border-radius: $borderradius--main;
                padding: ($padding--small / 4) ($padding--small / 1);
                transition: $transition--main;
                
                &:not(.selected) {
                    cursor: pointer;
                }

                &:hover {
                    background: $bg--light;
                }

                &:not(:last-of-type) {
                    margin-right: $margin--small / 2;
                }

                &.selected {
                    background: $color--dark;
                    color: $color--white;
                    font-weight: $fontweight--main;
                    cursor: default;
                }
            }
        }
    }
</style>

<style lang="scss">
.custom-time-period {
    .btn-group {
        height: unset !important;
        margin: 0px !important;
        padding: 0px !important;
    }
    .dropdown-toggle {
        padding: 0 !important;
        background: none !important;
        color: #172b43 !important;
        font-size: 14px !important;
        margin: 10px 0 0 0 !important;

        .caret {
            padding: 0px !important;
            margin: 0px !important;
            top: 17px !important;
            right: 8px !important;
            bottom: unset !important;
            left: unset !important;
        }
    }
}
</style>



// WEBPACK FOOTER //
// ConfigBar.vue?2e125312